import { getFromStorage } from "../../utils/storageUtils";
import { SessionLanguage } from "../../dtos/common/SettingsLanguage";
import { UpdateSettings } from "../../dtos/common/UpdateSettingsDto";
import instance, { get, patch, post } from "../../utils/BaseService";

const header = {
    access_token: localStorage.getItem("token"),
}

export async function getAllLanguages(dispatch: any): Promise<any> {
    return await get(dispatch, '/configuration/getAllLanguage', null)
};
export async function setSessionLanguage(dispatch: any, credentials: SessionLanguage): Promise<any> {
    return await post(dispatch, '/configuration/setSessionLanguage', credentials)
};

export async function updateSettings(dispatch: any, credentials: UpdateSettings): Promise<any> {
    return await instance.patch('/setting/updateSettings', credentials, {
        headers: header
    })
};

export async function createSettings(dispatch: any, credentials: {name:string,value:any}): Promise<any> {
    return await post(dispatch, '/settings/createSettings', credentials)
};
export async function findUpdateAndCreateSettings(dispatch: any, credentials: {userId:number|null,tenantId:number|null,name:string,value:any}): Promise<any> {
    return await post(dispatch, '/settings/saveAppSetting', credentials)
};

export async function getAllAppSettings(dispatch: any): Promise<any> {
    return await get(dispatch, '/configuration/getallappsetting', null)
};

export async function findSettingsByKey(dispatch: any, input: any): Promise<any> {
    return await get(dispatch, '/settings/findSettingsByKey', input)
}
export async function findSettingsByUserIdAndKey(dispatch: any, input: any): Promise<any> {
    return await get(dispatch, '/settings/findSettingsByUserIdAndKey', input)
}
